{
  "actions": { "send": "Submit" },
  "category1": "error in the assignment",
  "category2": "question on the assignment",
  "category3": "typo",
  "category4": "something doesn't work",
  "category5": "another problem",
  "error": {
    "maxFiles": "You can attach no more than {{ count }} {value, plural, one {{ screenshot }} other {{ screenshots }}.",
    "send": "Failed to send a message; please try again later."
  },
  "optionalMessage": "You may describe the problem",
  "optionalMessageAndAttach": "You may describe the problem and attach a screenshot",
  "placeholderSelect": "Select a problem category",
  "requiredMessage": "Describe the problem and attach a screenshot (if you wish)",
  "success": { "send": "Thank you for your attention!" },
  "title": "Error message",
  "titlePrefix": "In the card \"{{ name }}\"",
  "uploadFile": "Upload a file from your computer."
}
